
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 723.02 722.52"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Calque_1","data-name":"Calque 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M722.54 364.29c-.9 202.88-157.41 358.6-360 358.23C157.74 722.14-2.71 557 0 349.45 2.5 163.35 172-.65 360.94 0c199.44.69 372.34 170.5 361.6 364.29z"}}),_c('path',{attrs:{"d":"M52.18 363.16C51.71 187.92 186.95 52.51 362.67 52.27 538 52 676.42 188.2 675.77 361.63 675.19 517.39 561.23 673.57 364 674.57c-180.13.91-314.3-141.09-311.82-311.41z","fill":"#fefefe"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M567.5 363.51a27.36 27.36 0 01-27.18 27.22H390.19V540a27.27 27.27 0 01-54.54 0V390.72H187.78a27.31 27.31 0 110-54.61h147.87V186.85a27.27 27.27 0 0154.54 0v149.26h150.12a27.4 27.4 0 0127.19 27.4z"}})])])])
          )
        }
      }
    